{
  "schemaVersion": 1,
  "key": "jungle",
  "name": "Jungle",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/home.png",
    "calendar": "backgrounds/calendar.png",
    "day-of-school": "backgrounds/day-of-school.png",
    "number": "backgrounds/number.png"
  },
  "mascot": {
    "home": "mascot/toucan.png"
  }
}
